import { Model, Question } from "survey-core";
import { GtmEvent } from "~/lib/gtm/getGtmEventData";

/**
 * Builds the `questionaire_close` tracking event for the current survey page.
 *
 * Shared by the DS quiz variants' close buttons. The legacy quiz has no close
 * analytics and does not use this.
 */
export const buildQuizCloseEvent = (
    survey: Model | null,
    surveyID: string
): GtmEvent => {
    const lastActiveQuestion = survey?.currentPage.jsonObj;
    const questions: Question[] = survey?.currentPage.questions ?? [];

    const question = questions.find((q) => {
        return q["jsonObj"].choices;
    });

    const lastActiveQuestionAnswer =
        survey?.data[question?.["jsonObj"]?.name ?? lastActiveQuestion?.name];

    return {
        event: "user_interaction",
        value: {
            event_name: "questionaire_close",
            widget: "questionaire",
            meta_data: {
                click_text: null,
                quiz_id: surveyID,
                question_number: Object.keys(survey?.data || {}).length,
                question:
                    question?.["jsonObj"]?.name ??
                    lastActiveQuestion?.title ??
                    lastActiveQuestion?.name,
                number_of_answers: question?.["jsonObj"].choices.length ?? 1,
                answer_type: question?.["jsonObj"]?.type ?? "info",
                answers: Array.isArray(lastActiveQuestionAnswer)
                    ? lastActiveQuestionAnswer.join("_")
                    : lastActiveQuestionAnswer,
            },
        },
    };
};
